import React from "react";
import Box from "@mui/material/Box";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { visuallyHidden } from "@mui/utils";

import SortableTableHeadCell from "../../../domains/BasicTable/SortableTableHeadCell";

import { THeadCell, StyledTableSortLabel } from "./style";

type Order = "asc" | "desc"

interface Props<T> {
  onRequestSort: (property: keyof T) => void
  order: Order
  orderBy: string
  headCells: SortableTableHeadCell[]
  testId?: string
}

export default function SortableTableHeader<T>({
  order,
  orderBy,
  onRequestSort,
  headCells,
  testId = "",
}: Props<T>) {
  const createSortHandler = (property: keyof T) => () => {
    onRequestSort(property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell: SortableTableHeadCell) => {
          return (
            <THeadCell
              width={headCell.width}
              key={headCell.id}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <StyledTableSortLabel
                data-testid={testId}
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id as keyof T)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </StyledTableSortLabel>
            </THeadCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}
